import { FileButton } from '@/components/FileButton'
import { Button } from '@/components/Button'
import { ACCEPTED_OCR_FILE_TYPES } from '@/features/jobs/scoping/ocr-file-types'

export interface OCRScopeNewJobButtonProps {
  wideSlimButton?: boolean
  onAddFiles: (files: FileList) => unknown
  onOpen: () => unknown
}

export function OCRScopeNewJobButton({
  wideSlimButton = false,
  onAddFiles,
  onOpen,
}: OCRScopeNewJobButtonProps) {
  return (
    <FileButton
      stretchButton={wideSlimButton}
      multiple
      onChange={onAddFiles}
      accept={ACCEPTED_OCR_FILE_TYPES}
    >
      <Button
        label="Scope New Job"
        size={wideSlimButton ? 'wide-slim' : 'normal'}
        variant="primary"
        onPress={onOpen}
      />
    </FileButton>
  )
}
